import script from "./BalTextInputCreatePool.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalTextInputCreatePool.vue?vue&type=script&setup=true&lang=ts"

import "./BalTextInputCreatePool.vue?vue&type=style&index=0&id=1a2a8114&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a2a8114"]])

export default __exports__